/* eslint-disable @repo/internal/react/require-jsdoc */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Stack, xcss } from '@atlaskit/primitives';

import type { TokenValue } from './token-definition';

type MotionTokenCategoryProps = {
	tokenValue: TokenValue;
};

const motionStyles = xcss({
	font: 'font.code',
	color: 'color.text.subtlest',
});

/**
 * UI for representing a motion token.
 */

export const Motion = ({ tokenValue }: MotionTokenCategoryProps): React.JSX.Element => {
	return (
		<Box xcss={motionStyles}>
			{typeof tokenValue.value === 'string' && tokenValue.value}
			{typeof tokenValue.value === 'object' && (
				<Stack space="space.100">
					{tokenValue.value.keyframes?.map((value: string) => (
						<Box>{value}</Box>
					))}
					{tokenValue.value.properties?.map((value: string) => (
						<Box>{value}</Box>
					))}
					<Box>{tokenValue.value.duration}ms</Box>
					<Box>{tokenValue.original.value.curve}</Box>
				</Stack>
			)}
		</Box>
	);
};
